import { authStorage, login, type LoginApiResponse, type LoginRequest } from '@dc-trans/data-layer';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { mergeApiErrorNotificationMeta, type MutationOptionsWithNotification } from '@/mutations/utils';

// The custom hook that you will use in your components
export const useLoginMutation = (
  options?: MutationOptionsWithNotification<LoginApiResponse, AxiosError<LoginApiResponse>, LoginRequest>
) => {
  const { disableErrorNotification, meta, onSuccess, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal masuk. Silakan coba lagi.',
      hideTraceIdAction: true,
    },
    meta,
    disableErrorNotification
  );

  return useMutation<LoginApiResponse, AxiosError<LoginApiResponse>, LoginRequest>({
    ...restOptions,
    mutationFn: login,
    meta: mergedMeta,
    onSuccess: async (apiResponse, variables, context) => {
      const authData = apiResponse.data;

      if (authData) {
        authStorage!.setAuthData(authData);
      }

      await onSuccess?.(apiResponse, variables, context);
    },
  });
};
